import React from 'react';
import { MapPin, Award, Building2, Instagram, Facebook, Video, Youtube, Twitter, Mail, Phone, ExternalLink, Compass, Globe, Home as HomeIcon, Share2, Bell, ShieldCheck, TrendingUp } from 'lucide-react';
const profiles = [{
  title: 'Compass',
  icon: Compass,
  url: '#'
}, {
  title: 'Website',
  icon: Globe,
  url: '#'
}, {
  title: 'Realtor.com',
  icon: HomeIcon,
  url: '#'
}];
function getEavesRating(score: number) {
  if (score >= 86) return {
    label: 'Exceptional',
    color: 'text-emerald-400'
  };
  if (score >= 71) return {
    label: 'Very Good',
    color: 'text-emerald-400'
  };
  if (score >= 56) return {
    label: 'Good',
    color: 'text-amber-400'
  };
  if (score >= 41) return {
    label: 'Fair',
    color: 'text-orange-400'
  };
  return {
    label: 'Poor',
    color: 'text-red-400'
  };
}
export function ProfileHero() {
  const eavesScore = 87;
  const rating = getEavesRating(eavesScore);
  const handleShare = async () => {
    if (navigator.share) {
      await navigator.share({
        title: 'Marcus Chen — Eaves Pro Profile',
        text: "See Marcus Chen's verified performance data on Eaves",
        url: window.location.href
      });
    } else {
      await navigator.clipboard.writeText(window.location.href);
      alert('Link copied to clipboard!');
    }
  };
  return <section className="bg-brand-dark text-white pt-6 pb-16 px-6 md:px-12 rounded-b-[2.5rem] shadow-xl relative overflow-hidden" data-id="element-128">
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-forest opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-129"></div>

      <div className="max-w-6xl mx-auto" data-id="element-130">
        {/* Top bar */}
        <div className="flex items-center justify-between mb-12 relative z-10" data-id="element-131">
          <a href="/" className="inline-flex items-center gap-2 px-3 py-1.5 border border-white/20 hover:border-white/40 rounded-full transition-colors" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/tg3VtfRMGFLgjFkX7oevaV/eaves_favicon_transparent.png" alt="Eaves" className="h-5 w-5" data-id="element-133" />
            <span className="hidden sm:inline text-sm text-gray-300 font-serif font-medium tracking-wide" data-id="element-134">
              Eaves
            </span>
          </a>
          <div className="flex items-center gap-2" data-id="element-135">
            <button onClick={handleShare} className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-gray-300 hover:text-white border border-white/20 hover:border-white/40 rounded-full transition-colors" data-id="element-136">
              <Share2 size={15} data-id="element-137" />
              <span className="hidden sm:inline" data-id="element-138">Share</span>
            </button>
            <button className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm text-white bg-brand-forest hover:bg-brand-forestHover rounded-full transition-colors" data-id="element-139">
              <Bell size={15} data-id="element-140" />
              <span className="hidden sm:inline" data-id="element-141">Subscribe</span>
            </button>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-10 items-center md:items-start" data-id="element-142">
          {/* Profile Image + Pinnacle Badge */}
          <div className="relative shrink-0 flex flex-col items-center gap-3" data-id="element-143">
            <div className="w-48 h-48 md:w-56 md:h-56 rounded-full overflow-hidden border-4 border-brand-forest/30 shadow-2xl relative z-10" data-id="element-144">
              <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop" alt="Marcus Chen" className="w-full h-full object-cover" data-id="element-145" />
            </div>

            {/* Eaves Pinnacle Agent Badge */}
            <div className="relative -mt-4 z-20 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-1.5 flex items-center gap-2" data-id="element-146">
              <img src="https://cdn.magicpatterns.com/uploads/tg3VtfRMGFLgjFkX7oevaV/eaves_favicon_transparent.png" alt="Eaves" className="h-3.5 w-3.5" data-id="element-147" />
              <span className="text-xs font-medium text-brand-offwhite tracking-wide" data-id="element-148">
                Eaves Pinnacle Agent
              </span>
            </div>
          </div>

          {/* Profile Details */}
          <div className="flex-1 text-center md:text-left mt-4 md:mt-0 z-10" data-id="element-149">
            <div className="inline-flex items-center gap-2 bg-brand-forest/20 border border-brand-forest/30 text-brand-sage px-3 py-1.5 rounded-full mb-4 text-sm font-medium tracking-wide" data-id="element-150">
              <Building2 size={16} data-id="element-151" />
              <span data-id="element-152">Compass Real Estate · The Chen Group</span>
            </div>

            <h1 className="text-4xl md:text-6xl font-serif font-semibold mb-2 text-brand-offwhite" data-id="element-153">
              Marcus Chen
            </h1>
            <h2 className="text-xl md:text-2xl text-gray-300 font-serif italic mb-5" data-id="element-154">
              Senior real estate advisor
            </h2>

            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 md:gap-6 text-sm text-gray-400 mb-6" data-id="element-155">
              <span className="flex items-center gap-1.5" data-id="element-156">
                <MapPin size={16} className="text-brand-forest" data-id="element-157" />
                San Francisco Bay Area
              </span>
              <span className="hidden md:inline text-gray-600" data-id="element-158">·</span>
              <span className="flex items-center gap-1.5" data-id="element-159">
                <ShieldCheck size={16} className="text-brand-forest" data-id="element-160" />
                DRE #02145678 · Verified
              </span>
            </div>

            {/* Social + Contact */}
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mb-3" data-id="element-161">
              {[Instagram, Facebook, Video, Youtube, Twitter].map((Icon, i) => <a key={i} href="#" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-forest/60 flex items-center justify-center transition-colors" data-id="element-162">
                  <Icon size={18} data-id="element-163" />
                </a>)}
              <span className="w-px h-5 bg-white/20 mx-1" data-id="element-164"></span>
              <a href="mailto:marcus@chengroup.com" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-forest/60 flex items-center justify-center transition-colors" data-id="element-165">
                <Mail size={18} data-id="element-166" />
              </a>
              <a href="tel:+14155550198" className="w-9 h-9 rounded-full bg-white/10 hover:bg-brand-forest/60 flex items-center justify-center transition-colors" data-id="element-167">
                <Phone size={18} data-id="element-168" />
              </a>
            </div>

            {/* Profiles */}
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-2 mb-8" data-id="element-169">
              {profiles.map(p => {
              const Icon = p.icon;
              return <a key={p.title} href={p.url} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/10 hover:bg-brand-forest/60 text-sm text-gray-300 transition-colors" data-id="element-170">
                    <Icon size={14} data-id="element-171" />
                    <span data-id="element-172">{p.title}</span>
                    <ExternalLink size={12} className="opacity-50" data-id="element-173" />
                  </a>;
            })}
            </div>

            {/* Key credentials */}
            <div className="grid grid-cols-3 gap-4 pt-6 border-t border-white/10" data-id="element-174">
              <div data-id="element-175">
                <div className="flex items-center gap-2 mb-1" data-id="element-176">
                  <img src="https://cdn.magicpatterns.com/uploads/tg3VtfRMGFLgjFkX7oevaV/eaves_favicon_transparent.png" alt="Eaves" className="h-5 w-5" data-id="element-177" />
                  <p className="text-2xl font-mono text-brand-offwhite" data-id="element-178">
                    {eavesScore}
                  </p>
                </div>
                <p className="text-xs text-gray-400" data-id="element-179">
                  Eaves Score ·{' '}
                  <span className={`font-medium ${rating.color}`} data-id="element-180">
                    {rating.label}
                  </span>
                </p>
              </div>
              <div data-id="element-181">
                <p className="text-2xl font-mono text-brand-offwhite mb-1" data-id="element-182">
                  14 years
                </p>
                <p className="text-xs text-gray-400" data-id="element-183">Experience</p>
              </div>
              <div data-id="element-184">
                <p className="text-2xl font-mono text-brand-offwhite mb-1" data-id="element-185">
                  Top 13%
                </p>
                <p className="text-xs text-gray-400" data-id="element-186">In 94109</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}